import { formatDateWithDayjs } from "../../utils/utils";

export const COLUMNS = [
  {
    Header: "Sales Lead",
    Footer: "Sales Lead",
    accessor: "salesPersonLeadId"
  },
  {
    Header: "From Date",
    Footer: "From Date",
    accessor: "startDate",
    Cell: ({ value }) => formatDateWithDayjs(value, "DD-MMM-YYYY")
  },
  {
    Header: "To Date",
    Footer: "To Date",
    accessor: "endDate",
    Cell: ({ value }) => formatDateWithDayjs(value, "DD-MMM-YYYY")
  }
];
